// Tasks.

import type { CreateTaskInput, Task, TaskStatus, UpdateTaskInput } from "@/planning/model/wire.js";
import { api } from "@/platform/client";
import { qk } from "@/platform/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

// ---- tasks ----
export function useTasks(status?: TaskStatus) {
  return useQuery({
    queryKey: qk.tasks.list(status),
    queryFn: () => api.get<Task[]>(`/tasks${status ? `?status=${status}` : ""}`),
  });
}

function invalidateTasks(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: qk.tasks.all });
}

export function useCreateTask() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateTaskInput) => api.post<Task>("/tasks", input),
    onSuccess: () => invalidateTasks(qc),
  });
}

export function useUpdateTask() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, patch }: { id: number; patch: UpdateTaskInput }) =>
      api.patch<Task>(`/tasks/${id}`, patch),
    onSuccess: () => invalidateTasks(qc),
  });
}

export function useDeleteTask() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.del(`/tasks/${id}`),
    onSuccess: () => invalidateTasks(qc),
  });
}
